;(() => {
  const trackClickedFilter = function trackClickedFilter() {
    const $this = $(this)
    const gaLabel = $this.attr("data-ga-label")
    Activity.track("rooms filter", "click", gaLabel)
  }

  const showLoader = function showLoader(groupIndex) {
    const roomsGroup = $(`#rooms-${groupIndex}`)
    const loader = $("#rooms_cards_ghosts").html()

    roomsGroup.html(loader)
  }

  const onFilterClicked = function onFilterClicked() {
    const $this = $(this)
    const filters = $this.parent().find(".radio-switcher--i")
    filters.removeClass("radio-switcher--i_active")
    $this.addClass("radio-switcher--i_active")
    trackClickedFilter.call(this)
    showLoader($this.attr("data-rp-filter-gridx"))
  }

  const onRoomsReloadClicked = function onRoomsReloadClicked() {
    showLoader($(this).attr("data-rooms-loader-group-index"))
  }

  // Keep in sync with rooms_group_overlay_controller: it refreshes the mobile
  // overlay only on "cards:shown"; without this the overlay silently goes stale.
  const dispatchCardsShown = (event) => {
    const id = event.target.id
    if (!id || !id.startsWith("rooms_group_")) return

    const groupIndex = parseInt(id.slice("rooms_group_".length), 10)
    document.dispatchEvent(
      new CustomEvent("cards:shown", { detail: groupIndex, bubbles: true }),
    )
  }

  $(() => {
    $("body").on("click", ".radio-switcher--i", onFilterClicked)
    $("body").on(
      "click",
      "[data-rooms-loader-group-index]",
      onRoomsReloadClicked,
    )
  })

  document.addEventListener("turbo:frame-load", dispatchCardsShown)
})()
